import { useEffect, useState } from 'react';

/** True below the breakpoint; tracks the app root's width (not the viewport). */
export const useIsMobile = (breakpoint = 900) => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint,
  );

  useEffect(() => {
    const rootDiv = document.getElementById('rep-root');
    if (!rootDiv) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setIsMobile(entry.contentRect.width < breakpoint);
      }
    });
    resizeObserver.observe(rootDiv);
    return () => resizeObserver.disconnect();
  }, [breakpoint]);

  return isMobile;
};
